module.exports = __webpack_public_path__ + "img/icon-warning-circle.1a20422e.svg";